import { capitalize } from 'lodash';

export function formatOption(option: string) {
  const spaced = option.replace(/_/g, ' ');
  const words = spaced.split(' ');
  const capitalized = words.map((w) => capitalize(w));
  return capitalized.join(' ');
}
